import { render, staticRenderFns } from "./ConfirmWarehouseReceiver.vue?vue&type=template&id=c1045798"
import script from "./ConfirmWarehouseReceiver.vue?vue&type=script&lang=js"
export * from "./ConfirmWarehouseReceiver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports